import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './landing.css';
import { App } from './App';

/*
 * No theme, no service worker, no Supabase client.
 *
 * This page has no reader with a role, so `@harmony/theme`'s guy/gal/neutral
 * machinery has nothing to key off; it carries its own palette instead, taken
 * from the CREC mark. And it deliberately registers no worker: a worker
 * scoped at the origin root would claim /login/ and /app/ as well, which is
 * the one thing a landing page must not do.
 */
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
